<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<div id="navbar" class="navbar navbar-expand-lg">
					<!-- Page title -->
					<loading type="header" v-if="district.loaded == 0" />
					<div v-if="district.loaded != 0" class="navbar-text nav-title flex" id="pageTitle">
						{{ district.name }}
					</div>
				</div>

				<div class="content-main" style="background-color:white">
					<!-- Page content goes here -->
					<div class="h-100" v-if="district.loaded != 0">
						<div class="d-sm-flex b-t h-100">


							<edit-pane :cancel="loadData" :save="saveDistrict" :dirty="dirty" :valid="valid">
								<div class="tab-content h-100">
									<!-- District Details -->
									<div class="tab-pane" :class="{ active: tab == 1, show: tab == 1 }" id="tab-1">
										<div class="p-4 b-b _600 nav-title">District Details</div>
										<div role="form" class="col-12 col-xl-8">
											<div class="row m-0 pt-4">
												<div class="col-12">
													<div class="form-group" :class="{ invalid: !valid.field('name') }">
														<label>District Name</label>
														<input
															type="text"
															class="form-control"
															v-model="district.name"
														/>
													</div>
												</div>
												<div class="col-9">
													<div
														style="margin-bottom: 11px;"
														:class="{
															invalid: !(valid.field('ref') && valid.field('ref_char'))
														}"
													>
														<label>ID #</label>
														<input
															type="text"
															class="form-control"
															v-model.trim="district.ref_id"
														/>
														<small class="form-text text-muted"
															>Reference ID must be unique within this tenant</small
														>
													</div>
												</div>
												<div
													v-if="district.clever_sync || newDistrict"
													class="col-3 checkbox form-group align-self-end"
												>
													<label class="md-check">
														<input v-model="district.clever_sync" type="checkbox" />
														<i class="theme-accent"></i> Clever Sync
														<small class="form-text text-muted">&nbsp;</small>
													</label>
												</div>
												<template v-if="district.clever_sync">
													<div class="col-sm-6 col-12">
														<div
															class="form-group"
															:class="{ invalid: !valid.field('clever_id') }"
														>
															<label>Clever District ID</label>
															<input
																type="text"
																class="form-control"
																v-model="district.clever_id"
																:readonly="!newDistrict"
															/>
														</div>
													</div>
													<div class="col-sm-6 col-12 form-group">
														<label v-if="validSync">
															Last sync time:
															<span class="text-muted">{{
																fs.sinceString(this.district.last_sync)
															}}</span>
														</label>
														<label v-if="!validSync">
															Last sync time:
															<span class="text-muted">Never</span>
														</label>
														<button
															class="btn"
															v-b-modal.cleverSyncModal
															@click="openCleverSyncModal"
															:disabled="newDistrict"
															:class="{
																[newDistrict ? 'btn-secondary' : 'btn-success']: true
															}"
															style="display: block;"
														>
															Sync Clever Data...
														</button>
													</div>
													<div class="col-12 form-group">
														<label>Preferred Host</label>
														<input
															type="text"
															class="form-control"
															v-model="district.preferred_host"
														/>
														<small class="form-text text-muted"
															>Incoming Clever logins will be routed to this URL</small
														>
													</div>
												</template>
												<div class="col-sm-6 col-12">
													<div class="form-group" :class="{ invalid: !valid.field('name') }">
														<label>County</label>
														<input
															type="text"
															class="form-control"
															v-model="district.county"
														/>
													</div>
												</div>
												<div class="col-sm-6 col-12">
													<div class="form-group" :class="{ invalid: !valid.field('name') }">
														<label>City</label>
														<input
															type="text"
															class="form-control"
															v-model="district.city"
														/>
													</div>
												</div>
												<div class="col-6 checkbox form-group">
													<label class="md-check">
														<input v-model="district.validate_ids" type="checkbox" />
														<i class="theme-accent"></i> Validate Student IDs
													</label>
												</div>
												<div class="col-6 checkbox form-group">
													<label class="md-check">
														<input v-model="district.require_emails" type="checkbox" />
														<i class="theme-accent"></i> Require Student Emails
													</label>
												</div>
												<div v-if="district.validate_ids" class="col-12">
													<div
														class="form-group"
														:class="{ invalid: !valid.field('id_pattern') }"
													>
														<label>Validation Pattern</label>
														<input
															type="text"
															class="form-control"
															v-model="district.validation_pattern"
														/>
														<small class="form-text">
															Enter a validation pattern for student IDs
															<br />The format is as follows:
															<br />
															<table>
																<tr>
																	<td class="_600 text-center">a</td>
																	<td>- a lowercase letter</td>
																</tr>
																<tr>
																	<td class="_600 text-center">A</td>
																	<td>- a uppercase letter</td>
																</tr>
																<tr>
																	<td class="_600 text-center">@</td>
																	<td>- a letter, regardless of case</td>
																</tr>
																<tr>
																	<td class="_600 text-center">#</td>
																	<td>- a numerical digit</td>
																</tr>
																<tr>
																	<td class="_600 text-center">&amp;</td>
																	<td>- a letter or numerical digit</td>
																</tr>
																<tr>
																	<td class="_600 text-center">*</td>
																	<td>
																		- any character, including special characters
																	</td>
																</tr>
															</table>

															<br />For example, the pattern "aA##" would match a student
															ID of "mZ18"
														</small>
													</div>
												</div>
											</div>
										</div>
									</div>


								</div>
							</edit-pane>
							<save-optional-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveDistrict"
								:next="saveOptNext"
								:cancel="saveOptCancel"
								objectText="District"
								:objectName="district.name"
								actionText="leave the page"
								v-model="saveOptModal"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<b-modal id="cleverSyncModal" ref="cleverSyncModal" size="md" headerClass="indigo">
			<template slot="modal-title">
				<h3 class="modal-title full-bar-title">Sync Clever Data</h3>
			</template>
			<div v-if="syncStatus == 0" class="p-3">
				<label>Sync Type</label>
				<config-select :options="syncOptions" byField="id" sortBy="sequence" v-model="syncType" />
				<template v-if="syncType == 1">
					<h3 class="text-center mt-4 mb-3">Process updates:</h3>
					<p>The sync operation will only process updates since the last time it was run.</p>
					<p>This operation occurs automatically every night, but you can start it manually as well.</p>
					<p>Choose this option if you want to ensure Clever data is up-to-date.</p>
					<div class="text-muted text-center mb-3">Click the "Update" button to proceed.</div>
				</template>
				<template v-if="syncType == 2">
					<h3 class="text-center mt-4 mb-3">Full re-sync:</h3>
					<p>All schools, teachers, students, and classes will be reconstructed from Clever data.</p>
					<p>
						<span class="text-danger _600">Caution:</span> This may erase some class-specific settings, such
						as assignments that have been made within classes.
					</p>
					<p>
						Choose this option to onboard a district, to re-calculate district-to-curriculum mapping rules
						for all classes, or if EdGems data falls out of sync with Clever.
					</p>
					<div class="text-muted text-center mb-3 px-5">
						Click the "Sync" button to proceed. This process might take several minutes.
					</div>
				</template>
			</div>
			<div v-if="syncType == 1 && syncStatus == 1">
				<h3 class="text-center mt-4 mb-3">Processing updates...</h3>
				<loading type="page" />
			</div>
			<div v-if="syncType == 1 && syncStatus == 2">
				<h3 class="text-center mt-4 mb-3">Sync successful</h3>
				<p v-if="eventsSynced == 0 && eventsFailed == 0" class="text-muted text-center">
					No updates needed to be applied
				</p>
				<p v-if="eventsSynced > 0" class="text-muted text-center">{{ eventsSynced }} updates processed</p>
				<p
					v-if="eventsFailed > 0"
					class="text-danger text-center"
					v-tippy
					title="Some updates were not processed correctly. You may need to do a full sync, or contact an administrator."
				>
					<i class="fas fa-fw fa-exclamation-triangle" />
					{{ eventsFailed }} updates failed
				</p>
			</div>
			<div v-if="syncType == 2 && (syncStatus == 1 || syncStatus == 2) && syncData" class="p-3 text-md">
				<table class="w-100">
					<tr>
						<td class="nowrap">Syncing Schools:</td>
						<td class="w-100" style="padding-left: 20px;">
							<div class="progress-bar-bg">
								<div
									class="progress-bar progress-bar-striped bg-success"
									role="progressbar"
									:style="{ width: `${(100 * syncData.schools) / syncData.max_schools}%` }"
									v-tippy
									:title="
										`Schools: ${Math.round((100 * syncData.schools) / syncData.max_schools)}% (${
											syncData.schools
										} out of ${syncData.max_schools})`
									"
								></div>
							</div>
						</td>
					</tr>
					<tr>
						<td class="nowrap">Syncing Teachers:</td>
						<td class="w-100" style="padding-left: 20px;">
							<div class="progress-bar-bg">
								<div
									class="progress-bar progress-bar-striped bg-success"
									role="progressbar"
									:style="{ width: `${(100 * syncData.teachers) / syncData.max_teachers}%` }"
									v-tippy
									:title="
										`Teachers: ${Math.round((100 * syncData.teachers) / syncData.max_teachers)}% (${
											syncData.teachers
										} out of ${syncData.max_teachers})`
									"
								></div>
							</div>
						</td>
					</tr>
					<tr>
						<td class="nowrap">Syncing Students:</td>
						<td class="w-100" style="padding-left: 20px;">
							<div class="progress-bar-bg">
								<div
									class="progress-bar progress-bar-striped bg-success"
									role="progressbar"
									:style="{ width: `${(100 * syncData.students) / syncData.max_students}%` }"
									v-tippy
									:title="
										`Students: ${Math.round((100 * syncData.students) / syncData.max_students)}% (${
											syncData.students
										} out of ${syncData.max_students})`
									"
								></div>
							</div>
						</td>
					</tr>
					<tr>
						<td class="nowrap">Syncing Classes:</td>
						<td class="w-100" style="padding-left: 20px;">
							<div class="progress-bar-bg">
								<div
									class="progress-bar progress-bar-striped bg-success"
									role="progressbar"
									:style="{ width: `${(100 * syncData.sections) / syncData.max_sections}%` }"
									v-tippy
									:title="
										`Classes: ${Math.round((100 * syncData.sections) / syncData.max_sections)}% (${
											syncData.sections
										} out of ${syncData.max_sections})`
									"
								></div>
							</div>
						</td>
					</tr>
				</table>

				<template v-if="syncStatus == 2">
					<h3 class="text-center mt-4" :class="{ [syncData.errors.length ? 'mb-4' : 'mb-0']: true }">
						Finished syncing Clever data
					</h3>
					<div v-for="(error, i) in syncData.errors" :key="i" class="text-muted text-danger">{{ error }}</div>
				</template>
			</div>
			<template slot="modal-footer">
				<button v-if="syncStatus != 2" type="button" class="btn btn-primary" @click="closeCleverModal">
					Cancel
				</button>
				<template v-if="syncType == 1">
					<button v-if="syncStatus == 0" type="button" class="btn btn-success" @click="doEventSync">
						Update
					</button>
					<button v-if="syncStatus == 1" type="button" class="btn btn-success" disabled>
						Updating...
						<loading type="icon" />
					</button>
				</template>
				<template v-if="syncType == 2">
					<button v-if="syncStatus == 0" type="button" class="btn btn-success" @click="doCleverSync">
						Sync
					</button>
					<button v-if="syncStatus == 1" type="button" class="btn btn-success" disabled>
						Syncing...
						<loading type="icon" />
					</button>
				</template>
				<button v-if="syncStatus == 2" type="button" class="btn btn-success" @click="closeCleverModal">
					Finished
				</button>
			</template>
		</b-modal>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}

.progress-bar {
	height: 20px;
	width: calc(100% - 20px);
	border-radius: 4px;
}
.progress-bar-bg {
	height: 20px;
	top: 0;
	left: 0;
	width: 100%;
	background-color: lightgrey;
	border-radius: 4px;
}

progress[value] {
	/* Reset the default appearance */
	-webkit-appearance: none;
	appearance: none;

	width: 250px;
	height: 20px;
}
progress[value]::-webkit-progress-bar {
	background-color: #eee;
	border-radius: 2px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}
progress[value]::-webkit-progress-value {
	background-image: -webkit-linear-gradient(
			-45deg,
			transparent 33%,
			rgba(0, 0, 0, 0.1) 33%,
			rgba(0, 0, 0, 0.1) 66%,
			transparent 66%
		),
		-webkit-linear-gradient(top, rgba(255, 255, 255, 0.25), rgba(0, 0, 0, 0.25)),
		-webkit-linear-gradient(left, rgb(115, 154, 212), rgb(145, 194, 252));

	border-radius: 2px;
	background-size: 35px 20px, 100% 100%, 100% 100%;
}
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";

import DistrictService from "@/services/DistrictService";
import CleverSyncService from "@/services/CleverSyncService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import Utils from "@/services/Utils";

import axios from "axios";

var syncOptions = [
	{
		name: "Process updates",
		id: 1,
		sequence: 1
	},
	{
		name: "Full re-sync",
		id: 2,
		sequence: 2
	}
];

export default {
	name: "DistrictEdit",

	props: ["user", "params", "query"],

	components: {
		EditPane,
		SaveOptionalModal,
		ConfigSelect
	},

	data() {
		return {
			fs: fs,
			tab: 1,
			district: {
				loaded: 0
			},

			syncStatus: 0,
			syncData: null,
			syncPoll: null,
			syncOptions: syncOptions,
			syncType: 1,
			eventsSynced: 0,

			dirty: false,
			valid: {},
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},

	computed: {
		validSync() {
			if (!this.district || !this.district.last_sync || this.district.last_sync == "0001-01-01T00:00:00Z") {
				return false;
			}
			return true;
		},

		districtID() {
			return this.$route.params.id;
		},

		newDistrict() {
			return !fs.isObjectId(this.district.id);
		}
	},

	created() {
		this.loadData();
		this.initValidation();

		if (this.query.tab) {
			this.tab = this.query.tab;
		}
	},

	watch: {},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		initValidation() {
			this.valid = ValidationService.newValidator({
				name: {
					group: "details",
					errorMsg: "You must assign a name",
					func: () => {
						return this.district && this.district.name && this.district.name != "";
					}
				},
				ref: {
					group: "details",
					errorMsg: "You must assign a reference ID",
					func: () => {
						return this.district && this.district.ref_id && this.district.ref_id != "";
					}
				},
				ref_char: {
					group: "details",
					errorMsg:
						"Reference IDs may not contain spaces or any of the following characters: ! # % ^ * ( )  / [ ] { } < > ? | ' \" :",
					func: () => {
						return this.district && this.district.ref_id && fs.isGoodRefID(this.district.ref_id);
					}
				},
				id_pattern: {
					group: "details",
					errorMsg: "You must specify a validation pattern",
					func: () => {
						return this.district && (!this.district.validate_ids || this.district.validation_pattern);
					}
				},
				clever_id: {
					group: "details",
					errorMsg: "You must specify a valid Clever district ID",
					func: () => {
						return this.district && (!this.district.clever_sync || fs.isObjectId(this.district.clever_id));
					}
				}
			});
		},
		sync() {
			axios.post("/v1/admin/clever_sync/district/" + this.district.id);
		},

		blankDistrict() {
			return {
				schools: [],
				teachers: [],
				loaded: 0
			};
		},

		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"district",
				(newc, old) => {
					// console.log(newc, old);
					// console.log(Utils.diff(newc, old));
					// console.log("marking dirty");
					this.dirty = true;
				},
				{ deep: true }
			);
		},

		loadData() {
			console.log("Load district");
			this.dirty = false;
			var loaded = this.district.loaded;
			loaded++;

			if (this.params.id != "new") {
				DistrictService.getDistrict(this.params.id)
					.then(resp => {
						console.log("district received");
						this.district = resp.data;
						this.district.loaded = loaded;

						this.watchChanges();
					})
					.catch(err => {
						Notie.error("District not found, adding new district instead");
						this.$router.replace("/district/new");
					});
			} else {
				this.district = this.blankDistrict();
				this.district.loaded = loaded;
				this.$set(this.district, "name", "New District");
				this.$set(this.district, "ref_id", "new_district");
				this.watchChanges();
			}
		},

		saveDistrict() {
			return DistrictService.saveDistrict(this.district)
				.then(resp => {
					Notie.info("District Saved");
					if (this.district.id != resp.data.id) {
						this.$router.replace("/district/" + resp.data.id);
					}
					this.loadData();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save district", err);
				});
		},

		canSave() {
			return this.dirty;
		},

		openCleverSyncModal() {
			this.syncStatus = 0;
			this.syncType = 1;
			this.syncData = null;
		},

		doCleverSync() {
			this.syncStatus = 1;
			this.syncData = {
				schools: 0,
				max_schools: 1,
				teachers: 0,
				max_teachers: 1,
				students: 0,
				max_students: 1,
				sections: 0,
				max_sections: 1
			};
			CleverSyncService.sync(this.district.id)
				.then(r => {
					//this.syncData = r.data;
					setTimeout(this.updateSyncProgress, 250);
				})
				.catch(e => {
					console.log(e);
					Notie.error("Failed to start Clever sync", e);
				});
		},

		updateSyncProgress() {
			CleverSyncService.getSyncProgress(this.district.id)
				.then(r => {
					this.syncData = r.data;
					if (this.syncData.finished) {
						this.syncStatus = 2;
						this.loadData();
					} else {
						setTimeout(this.updateSyncProgress, 250);
					}
				})
				.catch(e => {
					console.log(e);
					Notie.error("Failed to get Clever sync progress", e);
				});
		},

		doEventSync() {
			this.syncStatus = 1;
			this.eventsSynced = 0;
			this.eventsFailed = 0;
			CleverSyncService.syncEvents(this.district.id)
				.then(r => {
					this.syncStatus = 2;
					this.eventsSynced = r.data.success;
					this.eventsFailed = r.data.failure;
					this.loadData();
				})
				.catch(e => {
					console.log(e);
					Notie.error("Failed to start Clever sync", e);
				});
		},

		closeCleverModal() {
			this.$refs["cleverSyncModal"].hide();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/DistrictEdit.vue